<template>
  <div>
    <span v-if="!propLog.automatico">
      {{ propLog.observacao }}
    </span>
    <div v-if="propLog.automatico">
      Dados alterados:
      <ul>
        <li v-for="key in Object.keys(returnJson(propLog.observacao))"
            :key="`item_${ key }_${ _uid }`">
          {{ key }}:
          <ul v-if="returnJson(propLog.observacao)[key] && (typeof returnJson(propLog.observacao)[key] == 'object' && Object.keys(returnJson(propLog.observacao)[key]).length > 0)">
            <li v-for="key2 in Object.keys(returnJson(propLog.observacao)[key])"
                :key="`subitem_${ key2 }_${ _uid }`">
              {{ key2 }}:
              <span>
                <b>{{ returnJson(propLog.observacao)[key][key2] }}</b>
              </span>
            </li>
          </ul>
          <span v-else>
            <b v-if="returnJson(propLog.observacao)[key]">{{ returnJson(propLog.observacao)[key] }}</b>
            <span v-else><s>dado foi removido</s></span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProtocoloObservacao",
    props: {
      propLog: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      returnJson (string) {
        return JSON.parse(string)
      }
    }
  }
</script>

<style scoped>

</style>
